import { isEmpty } from 'lodash';

import { TopicField } from '@app/origami-api/utils/topic-utils';
import { ErrorDescriptionHash, errorDescriptionString } from '../constants/errorDescriptionsFromBE';
import { getServerConfig } from '@app/origami-api/server-config';
import { BrandingTemplate } from '@app/origami-api/constants/branding-templates';

export function getErrorDescription(error: number | ErrorRecord | 'unknown', errorPattern?: string): string {
  const errorDescription: ErrorDescriptionHash =
    errorDescriptionString && errorDescriptionString[-1] ? errorDescriptionString : {};
  if (error == null) {
    return '';
  }
  if (typeof error === 'number') {
    return replacePlaceholders(errorDescription[error]) || error.toString();
  }
  if (error === 'unknown') {
    return 'Unknown error';
  }

  if (isEmpty(errorDescription[error.ErrorCode])) {
    return error.ErrorMessage || `${error.ErrorCode}`; // fallback; should not happen
  }

  if (errorDescription[error.ErrorCode].match(/{[0-5]}/g)) {
    errorPattern = errorDescription[error.ErrorCode];
  }

  return replacePlaceholders(
    (errorPattern || '{1}')
      .replace(/\{0\}/g, error.ObjectName)
      .replace(/\{1\}/g, error.ErrorMessage || errorDescription[error.ErrorCode] || errorDescription[-1])
      .replace(/\{2\}/g, '' + error.ObjectId)
      .replace(/\{3\}/g, '' + error.ErrorCode)
      .replace(/\{4\}/g, error.RelatedObjectName)
      .replace(/\{5\}/g, error.ObjectType),
  );
}

export function replacePlaceholders(errorDescription: string) {
  if (!errorDescription) return errorDescription;

  const config = getServerConfig();

  Object.entries(BrandingTemplate).forEach(([key, placeholder]) => {
    const value = config[key];
    if (value != null) {
      errorDescription = errorDescription.replace(new RegExp(placeholder, 'g'), String(value));
    }
  });

  return errorDescription;
}

export interface ErrorRecord {
  ErrorCode: number;
  ObjectId: number;
  ObjectName: string;
  ObjectType: string;
  ObjectTypeId?: number;
  ErrorMessage?: string;
  RelatedObjectId?: number;
  RelatedObjectType?: string;
  RelatedObjectTypeId?: string;
  SiteName?: string;
  AdditionalInformation?: TopicField[];
  RelatedObjectName?: string;
  Severity?: number;
}
